/** Schemes browsers serve an extension's own scripts from. */
const EXTENSION_URL_SCHEMES = [
    "chrome-extension://",
    "moz-extension://",
    "safari-web-extension://",
    "safari-extension://",
];
// The Datadog SDK writes a RUM error's stack as the error's name and message,
// which may run over several lines, then one
// `  at <function> @ <url>[:<line>[:<column>]]` line per frame. A line in any
// other shape is never read as an extension's frame, so a stack the SDK writes
// differently is kept rather than dropped.
const FRAME_LINE = /^\s+at /;
const FRAME_URL_SEPARATOR = " @ ";
function isExtensionFrame(frame) {
    const separator = frame.lastIndexOf(FRAME_URL_SEPARATOR);
    if (separator === -1) {
        return false;
    }
    const url = frame.slice(separator + FRAME_URL_SEPARATOR.length);
    return EXTENSION_URL_SCHEMES.some((scheme) => url.startsWith(scheme));
}
/**
 * Whether a RUM event is an error thrown entirely by a browser extension: one
 * whose every stack frame is in an extension's script.
 *
 * An error with no frames says nothing about where it came from, and one frame
 * outside an extension may be our code calling into an extension or called
 * back by one, so either is treated as ours.
 */
export function isBrowserExtensionError(event) {
    if (event.type !== "error") {
        return false;
    }
    const frames = (event.error?.stack ?? "")
        .split("\n")
        .filter((line) => FRAME_LINE.test(line));
    return frames.length > 0 && frames.every(isExtensionFrame);
}
//# sourceMappingURL=isBrowserExtensionError.js.map